import {
  AssetPermission,
  PermissionName
} from '../../../../components/FlowTeams/types/asset-permissions.types'
import { AssetPermissionsTableProps } from './AssetPermissionsTable'
import { Avatar } from '@dtx-company/design-system/src/components/Avatar/Avatar'
import { Box, Text } from '@dtx-company/shared-components/src'
import { PermissionsDropdownMenu } from './PermissionsDropdownMenu'
import { useAuthState } from '../../../../hooks/useAuthState'
import { useCurrentUsersAssetPermissions } from '../../hooks/asset-permissions/useCurrentUsersAssetPermissions'
import { useShowMobileStyles } from '../../../../components/FlowTeams/FlowTeams.hooks'
import React from 'react'

export const TableRow: React.FC<TableRowProps> = props => {
  const { showMobileStyles, editable, showRemoveItem } = useTableRowState(props)
  return (
    <Box display="flex" width="100%" justifyContent="space-between" alignItems="center" mb="16px">
      <PermissionEntityNameWithInitials permission={props.permission} />
      <Box minWidth={showMobileStyles ? '10px' : '150px'} justifyContent="flex-end">
        <PermissionsDropdownMenu
          {...props}
          trackingClickPermission={props.trackingClickPermission}
          disabled={!editable}
          hideRemoveItem={!showRemoveItem}
          isWhitelabel={props.isWhitelabel}
          isCodeSubdomain={props.isCodeSubdomain}
        />
      </Box>
    </Box>
  )
}

const PermissionEntityNameWithInitials: React.FC<{ permission: AssetPermission }> = ({
  permission
}) => {
  return (
    <Box
      display="flex"
      width="90%"
      alignItems="center"
      style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
    >
      <Avatar alt={permission.entityName} />
      <Box display="flex" flexDirection="column" ml="8px">
        <Box width="100%" display="table" style={{ tableLayout: 'fixed' }}>
          <Text
            display="table-cell"
            style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}
            fontWeight="bold"
            fontSize="14px"
            color="primary.black"
          >
            {permission.entityName}
          </Text>
        </Box>
      </Box>
    </Box>
  )
}

export function useTableRowState(props: TableRowProps): TableRowState {
  const { jwt } = useAuthState()
  const currentUserAssetPermissions = useCurrentUsersAssetPermissions(
    props.assetId,
    props.isWhitelabel,
    props.isCodeSubdomain
  )
  const currentUserIsViewer = currentUserAssetPermissions === PermissionName.VIEWER
  const currentUserIsOwner = currentUserAssetPermissions === PermissionName.OWNER
  const permissionIsCurrentUsersPermission = props.permission.entityId === jwt?.ithacaId
  const permissionIsCreatorsPermission = props.permission.permissionName === PermissionName.CREATOR
  const editable = !currentUserIsViewer && !permissionIsCreatorsPermission
  const showMobileStyles = useShowMobileStyles()
  const showRemoveItem =
    currentUserIsOwner || permissionIsCurrentUsersPermission || (props.isWhitelabel ?? false)
  return {
    editable,
    showMobileStyles,
    showRemoveItem
  }
}

interface TableRowState {
  editable: boolean
  showMobileStyles: boolean
  showRemoveItem: boolean
}

interface TableRowProps
  extends Pick<
    AssetPermissionsTableProps,
    | 'trackingClickPermission'
    | 'trackingClickPermissionDropdown'
    | 'assetId'
    | 'isWhitelabel'
    | 'isCodeSubdomain'
  > {
  permission: AssetPermission
}
